import { render } from "./GroupPermission.vue?vue&type=template&id=69cf3e53&scoped=true&ts=true"
import script from "./GroupPermission.vue?vue&type=script&lang=ts"
export * from "./GroupPermission.vue?vue&type=script&lang=ts"

import "./GroupPermission.vue?vue&type=style&index=0&id=69cf3e53&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cf3e53"]])

export default __exports__